<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.usuario"
                    label="Nome do usuário (login)"
                    v-model="model.usuario"
                />
            </rkm-col>

            <rkm-col :cols="model.novaSenha ? 3 : 6">
                <rkm-form-input
                    :label="id ? 'Nova senha' : 'Senha'"
                    :placeholder="id ? 'Para mudar sua senha, digite uma nova' : ''"
                    :validations="validations.novaSenha"
                    type="password"
                    v-model="model.novaSenha"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-if="model.novaSenha"
                    :label="id ? 'Confirmar nova senha' : 'Confirmar senha'"
                    :validations="validations.novaSenhaConfirmacao"
                    type="password"
                    v-model="model.novaSenhaConfirmacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Permissões"
                    type="fieldset"
                >
                    <rkm-form-checkbox-group
                        :options="form.permissoes"
                        class="m-0 p-0"
                        text-field="nome"
                        v-model="model.permissoes"
                        value-field="id"
                    />
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 6,
                    max: 150,
                },
                usuario: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                novaSenha: {
                    required: !this.id,
                    regex: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/,
                },
                novaSenhaConfirmacao: {
                    required: !!this.model.novaSenha,
                    is: this.model.novaSenha
                },
            }
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('webService.usuario'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.usuario.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.$watch('model.novaSenha', novaSenha => {
                            if (novaSenha) {
                                this.model.alterouSenha = true
                            }
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.usuario.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        usuario: this.model.usuario,
                        alterouSenha: this.model.alterouSenha,
                        permissoes: this.model.permissoes,
                    }

                    if (this.model.alterouSenha) {

                        request.novaSenha = this.model.novaSenha
                    }

                    if (this.id) {
                        this.repositories.usuario.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.usuario.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>